import * as z from 'zod/v4-mini';

export const loginSchema = z.object({
	name: z.string(),
	email: z.email()
});

export type LoginSchema = z.output<typeof loginSchema>;
